// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"af53af16","239":"a863f39a","667":"648c15b2"}[chunkId] + ".chunk.js";
};